import { setStore, getStore, removeStore } from './localStore';

// 缓存配置
const STORE_NAME = 'honyup_system';
const STORE_KEY_APP = 'honyup_system_app';
const STORE_KEY_VERIFICATION = 'is_verification';

/**
 * App 选择缓存管理类
 */
class AppStore {
  /**
   * 设置用户选择的 app
   * @param {string} appKey - app 的 key 值
   */
  setSelectedApp(appKey) {
    setStore({
      name: STORE_NAME,
      key: STORE_KEY_APP,
      content: appKey,
    });
  }

  /**
   * 获取用户选择的 app
   * @returns {string|null} 返回 app key 或 null
   */
  getSelectedApp() {
    return getStore({
      name: STORE_NAME,
      key: STORE_KEY_APP,
    });
  }

  /**
   * 设置验证状态
   * @param {boolean} isVerified - 是否已验证
   */
  setVerificationStatus(isVerified) {
    setStore({
      name: STORE_NAME,
      key: STORE_KEY_VERIFICATION,
      content: isVerified,
    });
  }

  /**
   * 获取验证状态
   * @returns {boolean|null} 返回验证状态或 null
   */
  getVerificationStatus() {
    return getStore({
      name: STORE_NAME,
      key: STORE_KEY_VERIFICATION,
    });
  }

  /**
   * 检查是否有有效的 app 选择（已验证且有选择）
   * @returns {boolean} 是否有有效的 app 选择
   */
  hasValidAppSelection() {
    const isVerified = this.getVerificationStatus();
    const selectedApp = this.getSelectedApp();
    return isVerified && selectedApp;
  }

  /**
   * 清除所有 app 相关缓存
   */
  clearAll() {
    removeStore({ name: STORE_NAME });
  }

  /**
   * 清除 app 选择缓存（保留验证状态）
   */
  clearAppSelection() {
    // 获取当前验证状态
    const isVerified = this.getVerificationStatus();
    // 清除整个存储
    removeStore({ name: STORE_NAME });
    // 重新设置验证状态
    if (isVerified) {
      this.setVerificationStatus(isVerified);
    }
  }
}

// 导出单例实例
export const appStore = new AppStore();

// 导出常量供其他地方使用
export const APP_STORE_KEYS = {
  STORE_NAME,
  STORE_KEY_APP,
  STORE_KEY_VERIFICATION,
};
